'use strict';

var base = require('./base');
var quickViewBase = require('base/product/quickView');

quickViewBase.addToCart = base.addToCart;

quickViewBase.flipImage = function () {
    $('body').on('mouseover mouseout', '.product-tile .image-container', function (event) {
        let tileImage = $(this).find('.tile-image');
        if (tileImage.length > 1) {
            if (event.type === 'mouseover') {
                tileImage.eq(1).show();
                tileImage.eq(0).hide();
            } else {
                tileImage.eq(0).show();
                tileImage.eq(1).hide();
            }
        }
    });
};

quickViewBase.showQuickAddButton = function () {
    $('body').on('mouseover mouseout', '.product-tile', function (event) {
        let quickAddButtonDiv = $(this).find('.quick-add-product');
        if (quickAddButtonDiv.length > 0) {
            if (event.type === 'mouseover') {
                quickAddButtonDiv.addClass('show');
            } else {
                quickAddButtonDiv.removeClass('show');
            }
        }
    });
};

quickViewBase.redirectToPdp = function () {
    $('body').on('product:beforeAddToCart', function (event, button) {
        $.spinner().start();
        let pdpUrl = $(button).attr('data-pdp-url');
        let isMaster = $(button).attr('data-is-master');
        if (isMaster === 'true' && pdpUrl !== undefined) {
            window.location.href = pdpUrl;
        }
    });
};

module.exports = quickViewBase;
